export const COUNTRIES = [{
	label: "United States",
	value: "USA"
},{
	label: "Canada",
	value: "CAN"
}, {
	label: "Afghanistan",
	value: "AFG"
}, {
	label: "Albania",
	value: "ALB"
}, {
	label: "Algeria",
	value: "DZA"
}, {
	label: "American Samoa",
	value: "ASM"
}, {
	label: "Andorra",
	value: "AND"
}, {
	label: "Angola",
	value: "AGO"
}, {
	label: "Anguilla",
	value: "AIA"
}, {
	label: "Antarctica",
	value: "ATA"
}, {
	label: "Antigua And Barbuda",
	value: "ATG"
}, {
	label: "Argentina",
	value: "ARG"
}, {
	label: "Armenia",
	value: "ARM"
}, {
	label: "Aruba",
	value: "ABW"
}, {
	label: "Australia",
	value: "AUS"
}, {
	label: "Austria",
	value: "AUT"
}, {
	label: "Azerbaijan",
	value: "AZE"
}, {
	label: "Bahamas",
	value: "BHS"
}, {
	label: "Bahrain",
	value: "BHR"
}, {
	label: "Bangladesh",
	value: "BGD"
}, {
	label: "Barbados",
	value: "BRB"
}, {
	label: "Belarus",
	value: "BLR"
}, {
	label: "Belgium",
	value: "BEL"
}, {
	label: "Belize",
	value: "BLZ"
}, {
	label: "Benin",
	value: "BEN"
}, {
	label: "Bermuda",
	value: "BMU"
}, {
	label: "Bhutan",
	value: "BTN"
}, {
	label: "Bolivia",
	value: "BOL"
}, {
	label: "Bosnia And Herzegowina",
	value: "BIH"
}, {
	label: "Botswana",
	value: "BWA"
}, {
	label: "Bouvet Island",
	value: "BVT"
}, {
	label: "Brazil",
	value: "BRA"
}, {
	label: "British Indian Ocean Territory",
	value: "IOT"
}, {
	label: "Brunei Darussalam",
	value: "BRN"
}, {
	label: "Bulgaria",
	value: "BGR"
}, {
	label: "Burkina Faso",
	value: "BFA"
}, {
	label: "Burundi",
	value: "BDI"
}, {
	label: "Cambodia",
	value: "KHM"
}, {
	label: "Cameroon",
	value: "CMR"
}, {
	label: "Cape Verde",
	value: "CPV"
}, {
	label: "Cayman Islands",
	value: "CYM"
}, {
	label: "Central African Republic",
	value: "CAF"
}, {
	label: "Chad",
	value: "TCD"
}, {
	label: "Chile",
	value: "CHL"
}, {
	label: "China",
	value: "CHN"
}, {
	label: "Christmas Island",
	value: "CXR"
}, {
	label: "Cocos (Keeling) Islands",
	value: "CCK"
}, {
	label: "Colombia",
	value: "COL"
}, {
	label: "Comoros",
	value: "COM"
}, {
	label: "Congo",
	value: "COG"
}, {
	label: "Congo, The Democratic Republic",
	value: "COD"
}, {
	label: "Cook Islands",
	value: "COK"
}, {
	label: "Costa Rica",
	value: "CRI"
}, {
	label: "Cote D'ivoire",
	value: "CIV"
}, {
	label: "Croatia (Local Name: Hrvatska)",
	value: "HRV"
}, {
	label: "Cuba",
	value: "CUB"
}, {
	label: "Cyprus",
	value: "CYP"
}, {
	label: "Czech Republic",
	value: "CZE"
}, {
	label: "Denmark",
	value: "DNK"
}, {
	label: "Djibouti",
	value: "DJI"
}, {
	label: "Dominica",
	value: "DMA"
}, {
	label: "Dominican Republic",
	value: "DOM"
}, {
	label: "East Timor",
	value: "TMP"
}, {
	label: "Ecuador",
	value: "ECU"
}, {
	label: "Egypt",
	value: "EGY"
}, {
	label: "El Salvador",
	value: "SLV"
}, {
	label: "England",
	value: "ENG"
}, {
	label: "Equatorial Guinea",
	value: "GNQ"
}, {
	label: "Eritrea",
	value: "ERI"
}, {
	label: "Estonia",
	value: "EST"
}, {
	label: "Ethiopia",
	value: "ETH"
}, {
	label: "Falkland Islands (Malvinas)",
	value: "FLK"
}, {
	label: "Faroe Islands",
	value: "FRO"
}, {
	label: "Fiji",
	value: "FJI"
}, {
	label: "Finland",
	value: "FIN"
}, {
	label: "France",
	value: "FRA"
}, {
	label: "France, Metropolitan",
	value: "FXX"
}, {
	label: "French Guiana",
	value: "GUF"
}, {
	label: "French Polynesia",
	value: "PYF"
}, {
	label: "French Southern Territories",
	value: "ATF"
}, {
	label: "Gabon",
	value: "GAB"
}, {
	label: "Gambia",
	value: "GMB"
}, {
	label: "Georgia",
	value: "GEO"
}, {
	label: "Germany",
	value: "DEU"
}, {
	label: "Ghana",
	value: "GHA"
}, {
	label: "Gibraltar",
	value: "GIB"
}, {
	label: "Greece",
	value: "GRC"
}, {
	label: "Greenland",
	value: "GRL"
}, {
	label: "Grenada",
	value: "GRD"
}, {
	label: "Guadeloupe",
	value: "GLP"
}, {
	label: "Guam",
	value: "GUM"
}, {
	label: "Guatemala",
	value: "GTM"
}, {
	label: "Guinea",
	value: "GIN"
}, {
	label: "Guinea-Bissau",
	value: "GNB"
}, {
	label: "Guyana",
	value: "GUY"
}, {
	label: "Haiti",
	value: "HTI"
}, {
	label: "Heard And Mc Donald Islands",
	value: "HMD"
}, {
	label: "Honduras",
	value: "HND"
}, {
	label: "Hong Kong",
	value: "HKG"
}, {
	label: "Hungary",
	value: "HUN"
}, {
	label: "Iceland",
	value: "ISL"
}, {
	label: "India",
	value: "IND"
}, {
	label: "Indonesia",
	value: "IDN"
}, {
	label: "Iran (Islamic Republic Of)",
	value: "IRN"
}, {
	label: "Iraq",
	value: "IRQ"
}, {
	label: "Ireland",
	value: "IRL"
}, {
	label: "Israel",
	value: "ISR"
}, {
	label: "Italy",
	value: "ITA"
}, {
	label: "Jamaica",
	value: "JAM"
}, {
	label: "Japan",
	value: "JPN"
}, {
	label: "Jordan",
	value: "JOR"
}, {
	label: "Kazakhstan",
	value: "KAZ"
}, {
	label: "Kenya",
	value: "KEN"
}, {
	label: "Kiribati",
	value: "KIR"
}, {
	label: "Korea, Democratic People's Rep",
	value: "PRK"
}, {
	label: "Korea, Republic Of",
	value: "KOR"
}, {
	label: "Kuwait",
	value: "KWT"
}, {
	label: "Kyrgyzstan",
	value: "KGZ"
}, {
	label: "Lao People's Democratic Republ",
	value: "LAO"
}, {
	label: "Latvia",
	value: "LVA"
}, {
	label: "Lebanon",
	value: "LBN"
}, {
	label: "Lesotho",
	value: "LSO"
}, {
	label: "Liberia",
	value: "LBR"
}, {
	label: "Libyan Arab Jamahiriya",
	value: "LBY"
}, {
	label: "Liechtenstein",
	value: "LIE"
}, {
	label: "Lithuania",
	value: "LTU"
}, {
	label: "Luxembourg",
	value: "LUX"
}, {
	label: "Macau",
	value: "MAC"
}, {
	label: "Macedonia, The Former Yugoslav",
	value: "MKD"
}, {
	label: "Madagascar",
	value: "MDG"
}, {
	label: "Malawi",
	value: "MWI"
}, {
	label: "Malaysia",
	value: "MYS"
}, {
	label: "Maldives",
	value: "MDV"
}, {
	label: "Mali",
	value: "MLI"
}, {
	label: "Malta",
	value: "MLT"
}, {
	label: "Marshall Islands",
	value: "MHL"
}, {
	label: "Martinique",
	value: "MTQ"
}, {
	label: "Mauritania",
	value: "MRT"
}, {
	label: "Mauritius",
	value: "MUS"
}, {
	label: "Mayotte",
	value: "MYT"
}, {
	label: "Mexico",
	value: "MEX"
}, {
	label: "Micronesia, Federated States Of",
	value: "FSM"
}, {
	label: "Moldova, Republic Of",
	value: "MDA"
}, {
	label: "Monaco",
	value: "MCO"
}, {
	label: "Mongolia",
	value: "MNG"
}, {
	label: "Montenegro",
	value: "MNE"
}, {
	label: "Montserrat",
	value: "MSR"
}, {
	label: "Morocco",
	value: "MAR"
}, {
	label: "Mozambique",
	value: "MOZ"
}, {
	label: "Myanmar",
	value: "MMR"
}, {
	label: "Namibia",
	value: "NAM"
}, {
	label: "Nauru",
	value: "NRU"
}, {
	label: "Nepal",
	value: "NPL"
}, {
	label: "Netherlands",
	value: "NLD"
}, {
	label: "Netherlands Antilles",
	value: "ANT"
}, {
	label: "New Caledonia",
	value: "NCL"
}, {
	label: "New Zealand",
	value: "NZL"
}, {
	label: "Nicaragua",
	value: "NIC"
}, {
	label: "Niger",
	value: "NER"
}, {
	label: "Nigeria",
	value: "NGA"
}, {
	label: "Niue",
	value: "NIU"
}, {
	label: "Norfolk Island",
	value: "NFK"
}, {
	label: "Northern Mariana Islands",
	value: "MNP"
}, {
	label: "Norway",
	value: "NOR"
}, {
	label: "Oman",
	value: "OMN"
}, {
	label: "Pakistan",
	value: "PAK"
}, {
	label: "Palau",
	value: "PLW"
}, {
	label: "Panama",
	value: "PAN"
}, {
	label: "Papua New Guinea",
	value: "PNG"
}, {
	label: "Paraguay",
	value: "PRY"
}, {
	label: "Peru",
	value: "PER"
}, {
	label: "Philippines",
	value: "PHL"
}, {
	label: "Pitcairn",
	value: "PCN"
}, {
	label: "Poland",
	value: "POL"
}, {
	label: "Portugal",
	value: "PRT"
}, {
	label: "Puerto Rico",
	value: "PRI"
}, {
	label: "Qatar",
	value: "QAT"
}, {
	label: "Reunion",
	value: "REU"
}, {
	label: "Romania",
	value: "ROM"
}, {
	label: "Russian Federation",
	value: "RUS"
}, {
	label: "Rwanda",
	value: "RWA"
}, {
	label: "Saint Kitts And Nevis",
	value: "KNA"
}, {
	label: "Saint Lucia",
	value: "LCA"
}, {
	label: "Saint Vincent And The Grenadin",
	value: "VCT"
}, {
	label: "Samoa",
	value: "WSM"
}, {
	label: "San Marino",
	value: "SMR"
}, {
	label: "Sao Tome And Principe",
	value: "STP"
}, {
	label: "Saudi Arabia",
	value: "SAU"
}, {
	label: "Scotland",
	value: "SCO"
}, {
	label: "Senegal",
	value: "SEN"
}, {
	label: "Serbia",
	value: "SRB"
}, {
	label: "Seychelles",
	value: "SYC"
}, {
	label: "Sierra Leone",
	value: "SLE"
}, {
	label: "Singapore",
	value: "SGP"
}, {
	label: "Slovakia (Slovak Republic)",
	value: "SVK"
}, {
	label: "Slovenia",
	value: "SVN"
}, {
	label: "Solomon Islands",
	value: "SLB"
}, {
	label: "Somalia",
	value: "SOM"
}, {
	label: "South Africa",
	value: "ZAF"
}, {
	label: "South Georgia And The South Sa",
	value: "SGS"
}, {
	label: "Spain",
	value: "ESP"
}, {
	label: "Sri Lanka",
	value: "LKA"
}, {
	label: "St. Helena",
	value: "SHN"
}, {
	label: "St. Pierre And Miquelon",
	value: "SPM"
}, {
	label: "Sudan",
	value: "SDN"
}, {
	label: "Suriname",
	value: "SUR"
}, {
	label: "Svalbard And Jan Mayen Islands",
	value: "SJM"
}, {
	label: "Swaziland",
	value: "SWZ"
}, {
	label: "Sweden",
	value: "SWE"
}, {
	label: "Switzerland",
	value: "CHE"
}, {
	label: "Syrian Arab Republic",
	value: "SYR"
}, {
	label: "Taiwan",
	value: "TWN"
}, {
	label: "Tajikistan",
	value: "TJK"
}, {
	label: "Tanzania, United Republic Of",
	value: "TZA"
}, {
	label: "Thailand",
	value: "THA"
}, {
	label: "Togo",
	value: "TGO"
}, {
	label: "Tokelau",
	value: "TKL"
}, {
	label: "Tonga",
	value: "TON"
}, {
	label: "Trinidad And Tobago",
	value: "TTO"
}, {
	label: "Tunisia",
	value: "TUN"
}, {
	label: "Turkey",
	value: "TUR"
}, {
	label: "Turkmenistan",
	value: "TKM"
}, {
	label: "Turks And Caicos Islands",
	value: "TCA"
}, {
	label: "Tuvalu",
	value: "TUV"
}, {
	label: "Uganda",
	value: "UGA"
}, {
	label: "Ukraine",
	value: "UKR"
}, {
	label: "United Arab Emirates",
	value: "ARE"
}, {
	label: "United Kingdom",
	value: "GBR"
}, {
	label: "United States Minor Outlying",
	value: "UMI"
}, {
	label: "Uruguay",
	value: "URY"
}, {
	label: "Uzbekistan",
	value: "UZB"
}, {
	label: "Vanuatu",
	value: "VUT"
}, {
	label: "Vatican City State (Holy See)",
	value: "VAT"
}, {
	label: "Venezuela",
	value: "VEN"
}, {
	label: "Viet Nam",
	value: "VNM"
}, {
	label: "Virgin Islands (British)",
	value: "VGB"
}, {
	label: "Virgin Islands (U.S.)",
	value: "VIR"
}, {
	label: "Wallis And Futuna Islands",
	value: "WLF"
}, {
	label: "Western Sahara",
	value: "ESH"
}, {
	label: "Yemen",
	value: "YEM"
}, {
	label: "Yugoslavia",
	value: "YUG"
}, {
	label: "Zaire",
	value: "ZAR"
}, {
	label: "Zambia",
	value: "ZMB"
}, {
	label: "Zimbabwe",
	value: "ZWE"
}];

export const US_STATES = [{
    label: "",
    value: ""
},{
	label: "Alabama",
	value: "AL"
}, {
	label: "Alaska",
	value: "AK"
}, {
	label: "American Samoa",
	value: "AS"
}, {
	label: "Arizona",
	value: "AZ"
}, {
	label: "Arkansas",
	value: "AR"
}, {
	label: "Armed Forced Other",
	value: "AE"
}, {
	label: "Armed Forces Americas",
	value: "AA"
}, {
	label: "Armed Forces Pacific",
	value: "AP"
}, {
	label: "California",
	value: "CA"
}, {
	label: "Colorado",
	value: "CO"
}, {
	label: "Connecticut",
	value: "CT"
}, {
	label: "Delaware",
	value: "DE"
}, {
	label: "District Of Columbia",
	value: "DC"
}, {
	label: "Federated States Of Micronesia",
	value: "FM"
}, {
	label: "Florida",
	value: "FL"
}, {
	label: "Georgia",
	value: "GA"
}, {
	label: "Guam",
	value: "GU"
}, {
	label: "Hawaii",
	value: "HI"
}, {
	label: "Idaho",
	value: "ID"
}, {
	label: "Illinois",
	value: "IL"
}, {
	label: "Indiana",
	value: "IN"
}, {
	label: "Iowa",
	value: "IA"
}, {
	label: "Kansas",
	value: "KS"
}, {
	label: "Kentucky",
	value: "KY"
}, {
	label: "Louisiana",
	value: "LA"
}, {
	label: "Maine",
	value: "ME"
}, {
	label: "Marshall Islands",
	value: "MH"
}, {
	label: "Maryland",
	value: "MD"
}, {
	label: "Massachusetts",
	value: "MA"
}, {
	label: "Michigan",
	value: "MI"
}, {
	label: "Minnesota",
	value: "MN"
}, {
	label: "Mississippi",
	value: "MS"
}, {
	label: "Missouri",
	value: "MO"
}, {
	label: "Montana",
	value: "MT"
}, {
	label: "Nebraska",
	value: "NE"
}, {
	label: "Nevada",
	value: "NV"
}, {
	label: "New Hampshire",
	value: "NH"
}, {
	label: "New Jersey",
	value: "NJ"
}, {
	label: "New Mexico",
	value: "NM"
}, {
	label: "New York",
	value: "NY"
}, {
	label: "North Carolina",
	value: "NC"
}, {
	label: "North Dakota",
	value: "ND"
}, {
	label: "Northern Mariana Islands",
	value: "MP"
}, {
	label: "Ohio",
	value: "OH"
}, {
	label: "Oklahoma",
	value: "OK"
}, {
	label: "Oregon",
	value: "OR"
}, {
	label: "Palau",
	value: "PW"
}, {
	label: "Pennsylvania",
	value: "PA"
}, {
	label: "Puerto Rico",
	value: "PR"
}, {
	label: "Rhode Island",
	value: "RI"
}, {
	label: "South Carolina",
	value: "SC"
}, {
	label: "South Dakota",
	value: "SD"
}, {
	label: "Tennessee",
	value: "TN"
}, {
	label: "Texas",
	value: "TX"
}, {
	label: "U.S. Minor Outlying Islands",
	value: "UM"
}, {
	label: "U.S. Virgin Islands",
	value: "VI"
}, {
	label: "Utah",
	value: "UT"
}, {
	label: "Vermont",
	value: "VT"
}, {
	label: "Virginia",
	value: "VA"
}, {
	label: "Washington",
	value: "WA"
}, {
	label: "West Virginia",
	value: "WV"
}, {
	label: "Wisconsin",
	value: "WI"
}, {
	label: "Wyoming",
	value: "WY"
}];
